import { defineStore } from 'pinia'
import { AsyncOperationState } from './lib/AsyncOperationState'
import {
  loadCategories,
  loadCollection,
  type Collection,
  type Menu,
} from '@/services/shop'
import Bugsnag from '@bugsnag/js'

export const useShopStore = defineStore('shop', {
  state: () => ({
    categories: null as Menu | null,
    collection: null as Collection | null,
    menuLoadState: AsyncOperationState.IDLE,
    collectionLoadState: AsyncOperationState.IDLE,
  }),
  actions: {
    async init() {
      await this.loadCategories()
    },
    async loadCategories() {
      try {
        this.menuLoadState = AsyncOperationState.IN_PROGRESS
        const res = await loadCategories()
        this.categories = res.data.menu
        this.menuLoadState = AsyncOperationState.DONE
      } catch (e) {
        this.menuLoadState = AsyncOperationState.ERRORED
        Bugsnag.notify(e as Error)
      }
    },
    async loadCollection(handle: string) {
      try {
        this.collectionLoadState = AsyncOperationState.IN_PROGRESS
        const res = await loadCollection(handle)
        this.collection = res.data.collection
        this.collectionLoadState = AsyncOperationState.DONE
      } catch (e) {
        this.collectionLoadState = AsyncOperationState.ERRORED
        Bugsnag.notify(e as Error)
      }
    },
  },

  getters: {
    collectionTitle: (state) => {
      const title = state.categories?.items.find(
        (item) => item.resource.handle === state.collection?.handle,
      )?.title
      if (title) {
        return title
      }
      return null
    },
  },
})
